import { useMutation } from '@tanstack/react-query';

import type { PermissionEnum, PortfolioProfileUserGroup } from 'src/api-sdk';
import type { MutationHookOptions } from 'src/types/global';
import { useAPI } from 'src/util/use-api';

type UseUpdateGroupPermissionForPortfolioParams = {
  portfolioId: string;
  groupId: string;
};

type Inputs = {
  permission: PermissionEnum;
};

export const useUpdateGroupPermissionForPortfolio = (
  { portfolioId, groupId }: UseUpdateGroupPermissionForPortfolioParams,
  options: MutationHookOptions<
    PortfolioProfileUserGroup | undefined,
    Error,
    Inputs
  > = {}
) => {
  const { API } = useAPI();

  return useMutation({
    mutationFn: async ({ permission }: Inputs) => {
      return (
        await API?.portfoliosAPI.portfoliosProfileUserGroupsPartialUpdate({
          portfolioId,
          profileUserGroupId: groupId,
          patchedPortfolioProfileUserGroupRequest: {
            permission,
          },
        })
      )?.data;
    },

    ...options,
  });
};
